import { Injectable, inject, signal } from '@angular/core';
import { GamesService } from './games.service';
import { filter, first, map, Observable, switchMap } from 'rxjs';
import { PlatformGraphQlService } from '../graphql/platform-graphql.service';
import { FiltersService } from 'ngx-unificator/services';
import { GameFilterStoreType, GamesListType } from '../../types/game.type';
import { UserService } from '../user/user.service';
import { lastPlayedListConfig } from '../../enums/game-config.enum';

@Injectable({
  providedIn: 'root',
})
export class LastPlayedGamesService {

  private _platformApi = inject(PlatformGraphQlService);
  private _games = inject(GamesService);
  private _filters = inject(FiltersService);
  private _user = inject(UserService);

  public lastPlayedListConfig = signal(lastPlayedListConfig);

  /**
   * Returns ready to use last played games list
   */
  public loadLastPlayedGameList$(filter?: GameFilterStoreType): Observable<GamesListType> {
    let idList: any[] = [];
    return this._platformApi.lastPlayedGamesList(true).pipe(
      map(e => e.data.result.gameSessions.edges.map(e => e.node.game.id)),
      switchMap(identifiers => {
        idList = identifiers;
        const arg: any = {
          'external_id[]': identifiers.length ? identifiers : null,
        };
        if (filter && filter?.wagering_allowed && filter?.wagering_contribution) {
          arg['wagering_allowed'] = filter?.wagering_allowed;
          arg['wagering_contribution'] = filter?.wagering_contribution;
        }
        return this._games.list({...arg});
      }),
      map((response: any) => ({
        ...response,
        gameList: this._filters.sortByArrayOrder(idList, 'externalId', response.gameList),
      })),
    );
  }

 public resolveLastPlayedGames() {
    this._user.auth$.pipe(
      filter(auth => auth),
      switchMap(() => this.loadLastPlayedGameList$()),
      first()
    ).subscribe((data) => {
      this.lastPlayedListConfig.update((config) => ({
        ...config,
        gameList: data.gameList,
      }));
    });
  }

}
